import Skeleton from '@mui/material/Skeleton';
import { Link, Translation } from '@ps/web-shared-components';
import React from 'react';

import Arrow from '@swf/core/assets/icons/arrow.svg';
import type { BreadcrumbItem } from '@swf/help';

import { TXTCLI_Home } from './Breadcrumb.messages.json';
import styles from './Breadcrumb.scss';

const Breadcrumb: React.FC<BreadcrumbItem> = ({ id, title }) => (
  <div className={styles.container}>
    <Link alias="helpCenter">
      <Translation {...TXTCLI_Home} />
    </Link>
    <Arrow className={styles.arrow} width={12} height={12} />
    {id === 'search-id' ? (
      <span>{title}</span>
    ) : (
      <Link alias="helpCenterCategoryArticles" values={{ category: id }}>
        {title}
      </Link>
    )}
  </div>
);

export const BreadcrumbSkeleton = () => (
  <div className={styles.container}>
    <Skeleton variant="text" width={38} />
    <Arrow className={styles.arrow} width={12} height={12} />
    <Skeleton variant="text" width={120} />
  </div>
);

export default Breadcrumb;
